import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/node_app/app/src/layouts/default.vue").then(m => m.default || m)),
  "my-account": defineAsyncComponent(() => import("/opt/node_app/app/src/layouts/my-account.vue").then(m => m.default || m))
}